document.addEventListener('DOMContentLoaded', function () {
  const selectedGrid = document.getElementById('selected-products-grid');
const slots = Array.from(selectedGrid.querySelectorAll('.mix_item'));
const discountSteps = ['15% Off', '20% Off', '25% Off'];

const oneTimeDiscountSteps = ['0% Off', '0% Off', '0% Off'];
let purchaseType = 'subscribe';
window.tieredBundlePurchaseType = purchaseType;
let suppressRechargeMinusSync = false;

function updateSlotStyles() {
  const filledCount = slots.filter(slot => slot.querySelector('.product-image-wrapper')).length;
  const currentDiscount = filledCount > 0 ? discountSteps[filledCount - 1] : null;
  const isOneTime = purchaseType === 'onetime';

  let firstEmptyIndex = slots.findIndex(slot => !slot.querySelector('.product-image-wrapper'));

  slots.forEach((slot, index) => {
    const hasProduct = slot.querySelector('.product-image-wrapper');
    const mixInfo = slot.querySelector('.mix_info');
    slot.classList.remove('active-slot');

    if (!hasProduct && index === firstEmptyIndex) {
      slot.classList.add('active-slot');
    }

    mixInfo.style.display = isOneTime ? 'none' : '';
    if (isOneTime) return;

    if (hasProduct) {
      mixInfo.textContent = currentDiscount;
    } else if (index === firstEmptyIndex) {
      mixInfo.textContent = 'Unlock ' + discountSteps[index];
    } else {
      mixInfo.textContent = discountSteps[index];
    }
  });
  updatePurchaseOptionLabels(filledCount);
  if (typeof renderProductSelectionBadges === 'function') {
    renderProductSelectionBadges();
  }
  updateMobileStickyVisibility(filledCount);
  updateCheckoutButtonVisibility(purchaseType);
}
updateSlotStyles();
function repositionProductGrid() {
  const desktopAnchor = document.getElementById('pg-desktop-anchor');
  const mobileAnchor = document.getElementById('pg-mobile-anchor');
  if (!selectedGrid || !desktopAnchor || !mobileAnchor) return;
  const isMobile = window.matchMedia('(max-width: 1007px)').matches;
  const anchor = isMobile ? mobileAnchor : desktopAnchor;
  if (anchor.nextElementSibling !== selectedGrid) {
    anchor.insertAdjacentElement('afterend', selectedGrid);
  }
}
repositionProductGrid();

function updateMobileStickyVisibility(filledCount) {
  const stickyBox = document.querySelector('.selected-bunlde-items');
  if (!stickyBox) return;
  stickyBox.classList.toggle('mobile-bundle-empty', filledCount === 0);
}
window.addEventListener('resize', () => {
  const filledCount = slots.filter(slot => slot.querySelector('.product-image-wrapper')).length;
  updateMobileStickyVisibility(filledCount);
  updateCheckoutButtonVisibility(purchaseType);
  repositionProductGrid();
});

function updatePurchaseOptionLabels(filledCount) {
  const currentPct = filledCount > 0
    ? discountSteps[filledCount - 1].replace(' Off', '')
    : '15%';

  const subscribeLabelEl = document.querySelector('.subscribe-pct');
  if (subscribeLabelEl) {
    subscribeLabelEl.textContent = currentPct;
  }
  document.querySelectorAll('.save-pct').forEach(savePctEl => {
    savePctEl.textContent = currentPct;
  });
}

  function updateBenefitsForPurchaseType(type) {
    document.querySelectorAll('.purchase-benefits [data-benefit]').forEach(li => {
      const benefit = li.dataset.benefit;
      if (benefit === 'shipping') return;
      const shouldCross = type === 'onetime';
      li.classList.toggle('benefit-crossed', shouldCross);
      li.classList.toggle('benefit-checked', !shouldCross);
    });
  }

  function updatePurchaseOptionActiveState(type) {
    document.querySelectorAll('.purchase-option').forEach(label => {
      const input = label.querySelector('input[name="purchase-type"]');
      label.classList.toggle('active', !!input && input.value === type);
    });
  }

  function updateCheckoutButtonVisibility(type) {
    const subscribeBtn = document.getElementById('mix_main_product');
    const otpBtn = document.getElementById('mix_main_product_otp');
    if (!subscribeBtn || !otpBtn) return;
    const isOneTime = type === 'onetime';
    const filledCount = slots.filter(slot => slot.querySelector('.product-image-wrapper')).length;
    const isMobile = window.innerWidth <= 1007;
    const hasAtLeastOneItem = filledCount >= 1;
    const mobileHide = isMobile && !hasAtLeastOneItem;

    subscribeBtn.style.display = (isOneTime || mobileHide) ? 'none' : '';
    otpBtn.style.display = (!isOneTime || mobileHide) ? 'none' : '';
  }

  function setCheckoutButtonsDisabled(disabled) {
    const subscribeBtn = document.getElementById('mix_main_product');
    const otpBtn = document.getElementById('mix_main_product_otp');
    if (subscribeBtn) subscribeBtn.disabled = disabled;
    if (otpBtn) otpBtn.disabled = disabled;
  }

  /*function updateShippingBenefit(subtotalNumber) {
    const shippingLi = document.querySelector('.purchase-benefits [data-benefit="shipping"]');
    if (!shippingLi) return;
    const qualifies = !isNaN(subtotalNumber) && subtotalNumber >= 100;
    shippingLi.classList.toggle('benefit-checked', qualifies);
    const desktopText = qualifies
      ? 'Free Shipping'
      : `You're $${(100 - subtotalNumber).toFixed(2)} away from Free Shipping`;

    const desktopTextEl = shippingLi.querySelector('.shipping-text-desktop');
    if (desktopTextEl) {
      desktopTextEl.textContent = desktopText;
    } else {
      shippingLi.textContent = desktopText;
    }
  }*/

  document.querySelectorAll('input[name="purchase-type"]').forEach(input => {
    input.addEventListener('change', (e) => {
      purchaseType = e.target.value;
      window.tieredBundlePurchaseType = purchaseType;
      updateBenefitsForPurchaseType(purchaseType);
      updateCheckoutButtonVisibility(purchaseType);
      updatePurchaseOptionActiveState(purchaseType);
      updateSlotStyles();
      updateBundlePrice();
    });
  });

  const initialChecked = document.querySelector('input[name="purchase-type"]:checked');
  updateBenefitsForPurchaseType(initialChecked ? initialChecked.value : 'subscribe');
  updateCheckoutButtonVisibility(initialChecked ? initialChecked.value : 'subscribe');
  updatePurchaseOptionActiveState(initialChecked ? initialChecked.value : 'subscribe');
const normalizeText = (s) => (s || '').replace(/\s+/g, ' ').trim();

  function waitForRechargeUpdate(previousText, { timeout = 4000, settleFor = 150 } = {}) {
    const previousNormalized = normalizeText(previousText);
    return new Promise((resolve) => {
      const wrapper = getRechargePriceWrapper();
      if (!wrapper) return resolve(false);

      let settled = false;
      let settleTimer = null;

      const observer = new MutationObserver(() => {
        const nowText = normalizeText(wrapper.textContent);
        if (nowText !== previousNormalized) {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(() => {
            if (settled) return;
            settled = true;
            observer.disconnect();
            resolve(true);
          }, settleFor);
        }
      });
      observer.observe(wrapper, { childList: true, characterData: true, subtree: true });

      setTimeout(() => {
        if (settled) return;
        settled = true;
        observer.disconnect();
        console.warn('[tiered-bundle] Timed out waiting for Recharge to update its price — displaying whatever is currently rendered.');
        resolve(false);
      }, timeout);
    });
  }
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.rb-btn-qty-plus');
    if (!btn) return;

    const item = btn.closest('.rb-item');
    if (!item) return;
    const productId = item.dataset.rbItemId;
    const imgSrc = item.querySelector('img').src;
    const title = item.querySelector('.rb-title').innerText;

    //if (alreadyAdded) return;
    const emptySlot = Array.from(selectedGrid.querySelectorAll('.mix__item_blockimg')).find(slot => slot.children.length === 0);

    if (!emptySlot) {
      alert("No empty slot available");
      const minusBtn = item.querySelector('.rb-btn-qty-minus');
      if (minusBtn && !minusBtn.disabled) {
        minusBtn.click();
      }
      return;
    }
    const productBlock = document.createElement('div');
    productBlock.classList.add('product-image-wrapper');
    productBlock.dataset.id = productId;
    productBlock.innerHTML = `
      <img src="${imgSrc}" alt="${title}" />
      <button class="remove-product" aria-label="Remove product">×</button>
    `;

    emptySlot.appendChild(productBlock);
    emptySlot.classList.add('img-adding');
    setCheckoutButtonsDisabled(false);
    updateSlotStyles();

    productBlock.querySelector('.remove-product').addEventListener('click', () => {
      productBlock.remove();

      if (!suppressRechargeMinusSync) {
        const minusBtn = document.querySelector(`[data-rb-item-id="${productId}"] .rb-btn-qty-minus`);
        if (minusBtn && !minusBtn.disabled) {
          minusBtn.click();
        }
      }

      emptySlot.classList.remove('img-adding');

      setTimeout(() => {
        const remainingProducts = Array.from(document.querySelectorAll('#selected-products-grid .product-image-wrapper'));
        slots.forEach(slot => {
          const block = slot.querySelector('.product-image-wrapper');
          if (block) block.remove();
          slot.classList.remove('img-adding');
        });
        remainingProducts.forEach((product, i) => {
          slots[i].querySelector('.mix__item_blockimg').appendChild(product);
          slots[i].querySelector('.mix__item_blockimg').classList.add('img-adding');
        });

        if (remainingProducts.length === 0) {
          document.querySelector('#bundle-price .sale-price').textContent = '$0.00';
          document.querySelector('#bundle-price .regular-price').textContent = '$0.00';
          currentBundleDisplayTotal = 0;
          currentBundleIsSubscribeMode = purchaseType !== 'onetime';
          syncFreeGifts();
        } else {
          updateBundlePrice();
        }
        updateSlotStyles();
      }, 300);
    });
    setTimeout(updateBundlePrice, 100);
  });
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    const minusBtn = e.target.closest('.rb-btn-qty-minus');
    if (!minusBtn) return;

    const item = minusBtn.closest('.rb-item');
    if (!item) return;
    const productId = item.dataset.rbItemId;

    const productBlocks = Array.from(
      selectedGrid.querySelectorAll(`.product-image-wrapper[data-id="${productId}"]`)
    );
    const lastBlock = productBlocks[productBlocks.length - 1];
    if (!lastBlock) return; // nothing of this product in the bundle to remove

    const removeBtn = lastBlock.querySelector('.remove-product');
    if (!removeBtn) return;
    
    suppressRechargeMinusSync = true;
    removeBtn.click();
    suppressRechargeMinusSync = false;
  });
  function updateBundlePrice() {
      const filledCount = slots.filter(slot => slot.querySelector('.product-image-wrapper')).length;
      const salePriceEl = document.querySelector('#bundle-price .sale-price');
      const regularPriceEl = document.querySelector('#bundle-price .regular-price');
      const youSaveEl = document.querySelector('#bundle-price .you-save');
      if (filledCount === 0) {
        if (salePriceEl) salePriceEl.textContent = '$0.00';
        if (regularPriceEl) {
          regularPriceEl.style.display = 'none';
          regularPriceEl.textContent = '$0.00';
        }
        if (youSaveEl) {
          youSaveEl.style.display = 'none';
          youSaveEl.textContent = '';
        }
        //updateShippingBenefit(0);
        currentBundleDisplayTotal = 0;
        currentBundleIsSubscribeMode = purchaseType !== 'onetime';
        syncFreeGifts();
        return;
      }

      const rechargePriceWrapper = document.querySelector('[aria-label^="Original price"]');

      if (!rechargePriceWrapper) return;

      const fullPriceEl = rechargePriceWrapper.querySelector('.rb-full-price');
      const actualPriceText = rechargePriceWrapper.textContent.replace(fullPriceEl?.textContent || '', '').trim();
      const fullPrice = fullPriceEl ? fullPriceEl.textContent.replace('US', '').trim() : '$0.00';
      const actualPrice = actualPriceText.replace('US', '').trim();

      const isOneTime = purchaseType === 'onetime';
      const displayedPrice = isOneTime ? (fullPrice || '$0.00') : (actualPrice || '$0.00');
      if (salePriceEl) salePriceEl.textContent = displayedPrice;
      if (regularPriceEl) {
        regularPriceEl.style.display = isOneTime ? 'none' : '';
        if (!isOneTime) regularPriceEl.textContent = fullPrice || '$0.00';
      }
      if (youSaveEl) {
        if (isOneTime) {
          youSaveEl.style.display = 'none';
          youSaveEl.textContent = '';
        } else {
          const fullNum = parseFloat((fullPrice || '0').replace(/[^0-9.]/g, '')) || 0;
          const saleNum = parseFloat((displayedPrice || '0').replace(/[^0-9.]/g, '')) || 0;
          const savedAmount = Math.max(0, fullNum - saleNum);
          const pct = discountSteps[filledCount - 1].replace(' Off', '');
          youSaveEl.style.display = '';
          youSaveEl.textContent = `YOU SAVE $${savedAmount.toFixed(2)} (${pct})`;
        }
      }

      //updateShippingBenefit(parseFloat(displayedPrice.replace(/[^0-9.]/g, '')));
       const displayedPriceNumber = parseFloat(displayedPrice.replace(/[^0-9.]/g, '')) || 0;
      currentBundleDisplayTotal = displayedPriceNumber;
      currentBundleIsSubscribeMode = !isOneTime;
       syncFreeGifts();
 }
 const GIFT_THRESHOLD = 115;
  const GIFT_STARTER_KIT_VARIANT_ID = 40452231299170;
  const GIFT_CREAMER_VARIANT_ID = 42199912972386;
  const GIFT_VARIANT_IDS = [GIFT_STARTER_KIT_VARIANT_ID, GIFT_CREAMER_VARIANT_ID];
  const GIFT_PROPERTY_KEY = '_free_gift';

  let currentBundleDisplayTotal = 0;
  let currentBundleIsSubscribeMode = false;

  async function fetchCart() {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error(`HTTP ${res.status} fetching /cart.js`);
    return res.json();
  }

  function findGiftLine(cart, variantId) {
    return cart.items.find(item => item.variant_id === variantId && item.properties && item.properties[GIFT_PROPERTY_KEY]);
  }

  async function addGift(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { [GIFT_PROPERTY_KEY]: 'true' } }],
      }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status} adding gift variant ${variantId}`);
  }

  async function removeGiftLine(line) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status} removing gift line ${line.key}`);
  }
  function findAnyLineForVariant(cart, variantId) {
  return cart.items.find(item => item.variant_id === variantId);
}

function findGiftLine(cart, variantId) {
  return cart.items.find(item => item.variant_id === variantId && item.properties && item.properties[GIFT_PROPERTY_KEY]);
}

  async function setGiftPresence(cart, variantId, shouldBePresent) {
  const existingAnyLine = findAnyLineForVariant(cart, variantId);
  const existingGiftLine = findGiftLine(cart, variantId);

  if (shouldBePresent) {
    if (existingAnyLine) return false;
    await addGift(variantId);
    return true;
  }
  if (!shouldBePresent && existingGiftLine) {
    await removeGiftLine(existingGiftLine);
    return true;
  }
  return false;
}

  let giftSyncInFlight = false;
  let giftSyncQueued = false;

  async function syncFreeGifts() {
    if (giftSyncInFlight) {
      giftSyncQueued = true;
      return;
    }
    giftSyncInFlight = true;
    try {
      let cart = await fetchCart();
      const realCartSubscriptionTotal = cart.items
        .filter(item => !GIFT_VARIANT_IDS.includes(item.variant_id) && item.selling_plan_allocation)
        .reduce((sum, item) => sum + item.line_price, 0) / 100;
      const inProgressSubscribeTotal = currentBundleIsSubscribeMode ? currentBundleDisplayTotal : 0;
      const combinedSubscriptionTotal = realCartSubscriptionTotal + inProgressSubscribeTotal;
      const wantsGift = combinedSubscriptionTotal > GIFT_THRESHOLD;

      const starterKitChanged = await setGiftPresence(cart, GIFT_STARTER_KIT_VARIANT_ID, wantsGift);
      if (starterKitChanged) {
        cart = await fetchCart(); // re-read so the creamer check below sees the Starter Kit line that was just added/removed
      }
      await setGiftPresence(cart, GIFT_CREAMER_VARIANT_ID, wantsGift);
    } catch (err) {
      console.warn('[tiered-bundle] Free gift sync failed:', err);
    } finally {
      giftSyncInFlight = false;
      if (giftSyncQueued) {
        giftSyncQueued = false;
        syncFreeGifts();
      }
    }
  }
  syncFreeGifts();
const checkoutBtn = document.getElementById('mix_main_product');
const checkoutBtnOTP = document.getElementById('mix_main_product_otp');

  function getRechargeAddToCartBtn() {
    return document.querySelector('.status-bar-sign-up .rb-form .rb-btn');
  }

  function getVariantIdForProduct(productId) {
    const data = (window.okendoReviewData || {})[productId];
    return data && data.variantId ? data.variantId : null;
  }

  function openCartAfterAdd() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    const cartDrawerTrigger = document.querySelector('.cart_dr');
    if (cartDrawerTrigger) {
      cartDrawerTrigger.click();
    } else {
      window.location.href = '/cart';
    }
  }

  function addOneTimeItemsToCart() {
    const productIds = Array.from(selectedGrid.querySelectorAll('.product-image-wrapper'))
      .map(el => el.dataset.id)
      .filter(Boolean);

    if (!productIds.length) return;
    const quantitiesByVariant = {};
    const missingVariantProductIds = [];

    productIds.forEach(productId => {
      const variantId = getVariantIdForProduct(productId);
      if (!variantId) {
        missingVariantProductIds.push(productId);
        return;
      }
      quantitiesByVariant[variantId] = (quantitiesByVariant[variantId] || 0) + 1;
    });

    if (missingVariantProductIds.length) {
      console.warn(
        `[tiered-bundle] Could not find a variant ID for product(s) ${missingVariantProductIds.join(', ')} — ` +
        'make sure every SKU in this bundle also has a matching "Review Product" block selected in the Theme ' +
        'Editor (that\'s currently where variant IDs are sourced from). These product(s) were skipped from the ' +
        'One-Time Purchase cart add.'
      );
    }

    const items = Object.keys(quantitiesByVariant).map(variantId => ({
      id: Number(variantId),
      quantity: quantitiesByVariant[variantId],
    }));

    if (!items.length) {
      alert('Something went wrong adding your bundle to cart — please try again or contact support.');
      return;
    }

    setCheckoutButtonsDisabled(true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(() => {
        openCartAfterAdd();
      })
      .catch(err => {
        console.warn('[tiered-bundle] One-Time Purchase cart add failed:', err);
        alert('Something went wrong adding your bundle to cart — please try again.');
      })
      .finally(() => {
        setCheckoutButtonsDisabled(false);
      });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      const rbAddToCartBtn = getRechargeAddToCartBtn();
      if (rbAddToCartBtn) {
        rbAddToCartBtn.click();
        return;
      }

      console.warn('[tiered-bundle] Recharge Add to Cart button not found at click time — retrying briefly in case the widget is still mounting.');
      let attempts = 0;
      const maxAttempts = 15; // ~3s at 200ms
      const retryTimer = setInterval(function () {
        attempts++;
        const btn = getRechargeAddToCartBtn();
        if (btn) {
          clearInterval(retryTimer);
          btn.click();
        } else if (attempts >= maxAttempts) {
          clearInterval(retryTimer);
          console.warn('[tiered-bundle] Recharge Add to Cart button still not found after retrying — Checkout could not be triggered. This usually means the Recharge widget markup/selector has changed; verify `.status-bar-sign-up .rb-form .rb-btn` still matches the live DOM.');
        }
      }, 200);
    });
  }
  if (checkoutBtnOTP) {
    checkoutBtnOTP.addEventListener('click', function () {
      addOneTimeItemsToCart();
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if(window.innerWidth > 1007){
  const stickyContainer = document.querySelector('#bundle-summary');
  const stickyBox = document.querySelector('.selected-bunlde-items');
  const startSection = document.querySelector('.tiered-bundle-discount');
  const footer = document.querySelector('#shopify-section-footer-newsletter');

  function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
  }

  function updateStickyPosition() {
    const windowTop = window.scrollY;
    const startTop = startSection.offsetTop;
    const endTop = startSection.offsetTop + startSection.offsetHeight - stickyBox.offsetHeight - 100; // 100 = top offset
    const isSticky = windowTop >= startTop && windowTop <= endTop;
    if (isSticky) {
      stickyBox.style.position = 'fixed';
      stickyBox.style.top = '100px'; // Matches sticky top
      stickyBox.style.bottom = 'auto';
      stickyBox.style.right = 'auto';
      stickyBox.style.width = stickyContainer.offsetWidth + 'px';
    } else if (windowTop > endTop) {
      stickyBox.style.position = 'absolute';
      stickyBox.style.top = 'auto';
      stickyBox.style.bottom = '0';
      stickyBox.style.right = 'auto';
    } else {
      stickyBox.style.position = 'absolute';
      stickyBox.style.top = '0';
      stickyBox.style.bottom = 'auto';
    }
  }
  window.addEventListener('scroll', updateStickyPosition);
  window.addEventListener('resize', updateStickyPosition);
  updateStickyPosition();
  }
});

  function renderStaticReviews() {
  const reviewData = window.okendoReviewData || {};
  document.querySelectorAll('.rb-item').forEach(item => {
    const productId = item.getAttribute('data-rb-item-id');
    const data = productId ? reviewData[productId] : null;

    if (data && data.reviewCount && !item.querySelector('.static-review')) {
      const container = document.createElement('div');
      container.className = 'static-review ttext-sm ttext-gray-600 tflex titems-center tgap-1';

      container.innerHTML = `
          <span class="ttext-yellow-500">★★★★★</span>
          <span class="ttext-xs tml-1">(${data.reviewCount} Reviews)</span>
        `;

      const title = item.querySelector('.rb-item-content .tflex');
      if (title) title.insertAdjacentElement('afterend', container);
    }
  });
}

function updateRechargeIncentiveLabels() {
  document.querySelectorAll('.incentive-tier__quantity').forEach(qtyEl => {
    const match = qtyEl.textContent.match(/(\d+)/);
    if (!match) return;
    const qty = parseInt(match[1], 10);
    if (!qty || qty < 1 || qty > discountStepsGlobal.length) return;

    const pct = discountStepsGlobal[qty - 1].replace(' Off', '');
    const titleEl = qtyEl.parentElement && qtyEl.parentElement.querySelector('.incentive-tier__title');
    if (!titleEl) return;

    const desiredText = `Save ${pct}`;
    if (titleEl.textContent.trim() !== desiredText) {
      titleEl.textContent = desiredText;
    }
  });
}
// Mirrors the discountSteps array declared inside the first
// DOMContentLoaded closure above (15%/20%/25%) — duplicated at this
// outer scope since updateRechargeIncentiveLabels() and its init code
// below live outside that closure, alongside the other Recharge-grid
// enhancement functions.
const discountStepsGlobal = ['15% Off', '20% Off', '25% Off'];

function renderProductSelectionBadges() {
  document.querySelectorAll('.rb-item').forEach(item => {
    const productId = item.getAttribute('data-rb-item-id');
    const imgWrapper = item.querySelector('.rb-item-img');
    if (!productId || !imgWrapper) return;
    let badge = imgWrapper.querySelector('.product-select-badge');
    if (!badge) {
      badge = document.createElement('button');
      badge.type = 'button';
      badge.className = 'product-select-badge';
      imgWrapper.appendChild(badge);
      badge.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); // this tile's "Learn more" overlay button sits underneath the badge
        const isSelected = badge.classList.contains('is-selected');
        if (isSelected) {
          const productBlock = document.querySelector(`#selected-products-grid .product-image-wrapper[data-id="${productId}"]`);
          const removeBtn = productBlock && productBlock.querySelector('.remove-product');
          if (removeBtn) removeBtn.click();
        } else {
          const plusBtn = item.querySelector('.rb-btn-qty-plus');
          if (plusBtn && !plusBtn.disabled) plusBtn.click();
        }
      });
    }
    const isSelected = !!document.querySelector(`#selected-products-grid .product-image-wrapper[data-id="${productId}"]`);
    badge.classList.toggle('is-selected', isSelected);
    const itemLabel = item.getAttribute('aria-label') || 'this product';
    badge.setAttribute('aria-label', isSelected ? `Remove ${itemLabel} from your bundle` : `Add ${itemLabel} to your bundle`);
    const desiredText = isSelected ? '✓' : '+';
    if (badge.textContent !== desiredText) {
      badge.textContent = desiredText;
    }
    const actions = item.querySelector('.rb-item-actions');
    if (actions) {
      actions.classList.toggle('qty-active', isSelected);
    }
  });
}
  function renderStaticPricesInButtons() {
  document.querySelectorAll('.rb-item').forEach(item => {
    const priceEl = item.querySelector('.rb-price');
    if (!priceEl) return;

    const plusBtn = item.querySelector('.rb-btn-qty-plus');
    if (!plusBtn) return;
    plusBtn.querySelectorAll('.btn-price').forEach((el, i) => {
      if (i > 0) el.remove();
    });

    const clonedPrice = priceEl.cloneNode(true);
    clonedPrice.querySelectorAll('.tstrike').forEach(strike => strike.remove());

    const newPrice = clonedPrice.textContent.replace('US', '').trim();
    if (!newPrice) return;

    let btnPriceEl = plusBtn.querySelector('.btn-price');
    if (!btnPriceEl) {
      btnPriceEl = document.createElement('span');
      btnPriceEl.className = 'btn-price';
      plusBtn.appendChild(btnPriceEl);
    }
    btnPriceEl.textContent = ` - ${newPrice}`;
  });
}

function initStaticPricesInButtons() {
  document.querySelectorAll('.rb-item').forEach(item => {
    const priceEl = item.querySelector('.rb-price');
    if (!priceEl) return;

    // Clone price element without the .tstrike old price
    const clonedPrice = priceEl.cloneNode(true);
    clonedPrice.querySelectorAll('.tstrike').forEach(strike => strike.remove());

    const newPrice = clonedPrice.textContent.replace('US', '').trim();
    if (!newPrice) return;

    // Find the plus button
    const plusBtn = item.querySelector('.rb-btn-qty-plus');
    if (!plusBtn) return;

    // Add data attribute for easy re-adding
    plusBtn.setAttribute('data-price', newPrice);

    // Add the price inside the button
    if (!plusBtn.querySelector('.btn-price')) {
      const span = document.createElement('span');
      span.className = 'btn-price';
      span.textContent = ` - ${newPrice}`;
      plusBtn.appendChild(span);
    }
  });
}
document.addEventListener('DOMContentLoaded', () => {
  renderStaticReviews(); initStaticPricesInButtons(); renderProductSelectionBadges();
  const sortSelect = document.getElementById('sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      sortProducts(e.target.value);
    });
  }
const grid = document.querySelector('.recharge-grid-container') || document.body; const observer = new MutationObserver(() => {
   renderStaticReviews(); initStaticPricesInButtons(); renderProductSelectionBadges(); });
   observer.observe(grid, { childList: true, subtree: true });
})
document.addEventListener('click', function (e) {
  if (e.target.closest('.rb-btn-qty-plus') || e.target.closest('.remove-product')) {
    setTimeout(function () {
      renderStaticPricesInButtons();
      renderProductSelectionBadges();
    }, 300);// Delay to let DOM update
  }
});
  document.addEventListener('DOMContentLoaded', () => {
  function initRechargeEnhancements() {
    const grid = document.querySelector('.recharge-grid-container');
    if (!grid || !grid.querySelector('.rb-item')) return false; // not ready yet
    renderStaticPricesInButtons();
    renderProductSelectionBadges();

    // Watch for future changes
    const observer = new MutationObserver(() => {
      renderStaticPricesInButtons();
      renderProductSelectionBadges();
    });
    observer.observe(grid, { childList: true, subtree: true });

    return true;
  }

  // Keep checking every 300ms until the grid is ready
  const checkGridInterval = setInterval(() => {
    if (initRechargeEnhancements()) {
      clearInterval(checkGridInterval);
    }
  }, 300);
});

// Recharge's incentive-tier bar isn't guaranteed to be mounted yet at
// page load (it's part of the "@app" block's own async render), so poll
// briefly for it, then keep a MutationObserver attached for as long as
// the page lives so the relabeled text survives every future
// cart-driven re-render (Recharge redraws this bar itself whenever
// quantity changes).
document.addEventListener('DOMContentLoaded', () => {
  (function initIncentiveLabelOverride() {
    function attemptRun() {
      const container = document.querySelector('.rb-incentives-status__container');
      if (!container) return false;
      updateRechargeIncentiveLabels();
      const observer = new MutationObserver(() => updateRechargeIncentiveLabels());
      observer.observe(container, { childList: true, subtree: true, characterData: true });
      return true;
    }
    if (attemptRun()) return;
    const incentiveCheckInterval = setInterval(() => {
      if (attemptRun()) clearInterval(incentiveCheckInterval);
    }, 300);
  })();
});